/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CategoryModalUpdateMutationVariables = {|
  id: string,
  name?: ?string,
|};
export type CategoryModalUpdateMutationResponse = {|
  +recipeCategoryUpdate: ?{|
    +recipeCategory: ?{|
      +id: string,
      +name: string,
      +picture: ?string,
    |}
  |}
|};
export type CategoryModalUpdateMutation = {|
  variables: CategoryModalUpdateMutationVariables,
  response: CategoryModalUpdateMutationResponse,
|};
*/


/*
mutation CategoryModalUpdateMutation(
  $id: ID!
  $name: String
) {
  recipeCategoryUpdate(input: {id: $id, name: $name}) {
    recipeCategory {
      id
      name
      picture
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeCategoryUpdatePayload",
    "kind": "LinkedField",
    "name": "recipeCategoryUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNode",
        "kind": "LinkedField",
        "name": "recipeCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "picture",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryModalUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CategoryModalUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CategoryModalUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CategoryModalUpdateMutation(\n  $id: ID!\n  $name: String\n) {\n  recipeCategoryUpdate(input: {id: $id, name: $name}) {\n    recipeCategory {\n      id\n      name\n      picture\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f9fff3b89db1192724a5ccf8c38d0b09';

module.exports = node;
